<div id="employee-table">
  <ep-employee-table
    [employees]="employees$ | async"
    (addNew)="addNew()"
    (rowClick)="rowClick($event)"
  ></ep-employee-table>
</div>
